import {
  DATA_ROOM_DASHBOARD_TIMEFRAME,
  DataRoomDashboardTimeframe,
} from 'router/subrouters/DataRoom/models/Dashboard';

export type TimeframeFilterValue = DataRoomDashboardTimeframe;

export const TIMEFRAME_FILTER_OPTIONS = Object.values(
  DATA_ROOM_DASHBOARD_TIMEFRAME,
);

export const TIMEFRAME_FILTER_COPY = {
  [DATA_ROOM_DASHBOARD_TIMEFRAME.TODAY]: 'today',
  [DATA_ROOM_DASHBOARD_TIMEFRAME.YESTERDAY]: 'yesterday',
  [DATA_ROOM_DASHBOARD_TIMEFRAME.SEVEN_DAYS]: '7D',
  [DATA_ROOM_DASHBOARD_TIMEFRAME.FOURTEEN_DAYS]: '14D',
  [DATA_ROOM_DASHBOARD_TIMEFRAME.THIRTY_DAYS]: '30D',
  [DATA_ROOM_DASHBOARD_TIMEFRAME.SIXTY_DAYS]: '60D',
} as Record<string, string>;
